(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-with-search"] && !Shopify.designMode) return;
  try {
    
  Sellfino_Helpdesk = function() {
    this.input = this.q('.sllf-helpdesk__search'),
    this.qas = this.q('.sllf-helpdesk__qa', true),
	this.notFound = this.q('.sllf-helpdesk__notfound');
    this.init();
  }

  Sellfino_Helpdesk.prototype = {
    init: function () {
      var _this = this,
          form = this.q('.sllf-helpdesk__form'),
          questions = this.q('.sllf-helpdesk__question', true);

      questions.forEach(function(question) {
        question.addEventListener('click', function(e) {
          e.preventDefault();
          _this.qas.forEach(function(qa) {
            var answer = qa.querySelector('.sllf-helpdesk__answer');
            if (qa == e.target.parentElement) {
              qa.classList.contains('sllf-helpdesk__qa-active') ? _this.slideUp(answer) : _this.slideDown(answer);
            } else {
              _this.slideUp(answer);
            }
          });
        });
      });

      form.addEventListener('submit', function(e) {
        e.preventDefault();
        _this.search();
      });

      ['input', 'blur', 'keydown'].forEach(function(e) {
        _this.input.addEventListener(e, _this.search.bind(_this));
      });

    },
    q: function(element, all = false) {
      return all ? document.querySelectorAll(element) : document.querySelector(element);
    },
    slideDown: function(element) {
      element.parentElement.classList.add('sllf-helpdesk__qa-active');
      element.style.height = 'auto';
      var height = element.clientHeight + 'px';
      element.style.height = '0px';

      setTimeout(function() {
        element.style.height = height;
      }, 0) 
    },
    slideUp: function(element) {
      element.style.height = '0px';
      element.addEventListener('transitionend', function() {
        element.parentElement.classList.remove('sllf-helpdesk__qa-active')
      }, {once: true});
    },
    search: function() {
      var value = this.input.value, titlesArr = [], titlesArrIndex = -1, noResults = true;
	  this.qas.forEach(function(qa) {
        if (qa.innerText.toLowerCase().indexOf(value.toLowerCase()) > -1) {
          qa.style.display = 'block';
        } else {
          qa.style.display = 'none';
        }
      });
	  
      this.q('.sllf-helpdesk__body .sllf-helpdesk__container', true).forEach(function(container) {
		[].forEach.call(container.children, function(element) {
          if (!element.classList.contains('sllf-helpdesk__notfound')) {
            if (element.classList.contains('sllf-helpdesk__title')) {
              titlesArrIndex++;
              titlesArr[titlesArrIndex] = {
                section: element,
                elements: []
              };
            } else {
              titlesArr[titlesArrIndex].elements.push(element);
            }
          }
        });
      });
	  
	  titlesArr.forEach(function(title) {
		var hide = true;
 	    title.elements.forEach(function(element) {
		  if (element.style.display != 'none') {
		    hide = noResults = false;
          }
        });

		hide ? title.section.style.display = 'none' : title.section.style.display = 'block';
      });

	  if (noResults) {
	  	this.notFound.style.display = 'block';
      } else {
	  	this.notFound.style.display = 'none';
      }
    }
  }

  new Sellfino_Helpdesk();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-hulkapps-backup"]) return;
  try {
    
  let hoverMenus = document.getElementsByClassName('dropdown-menu__custom_hover');

  for(let i = 0; i < hoverMenus.length; i++){
    let hoverMenusDetails = hoverMenus[i].querySelector("details");

    hoverMenus[i].addEventListener('mouseover', function(){
      if (!hoverMenusDetails.hasAttribute('open')){
        hoverMenusDetails.setAttribute('open', '');
      }
    })

    hoverMenus[i].addEventListener('mouseout', function(){
      if (hoverMenusDetails.hasAttribute('open')){
        hoverMenusDetails.removeAttribute('open', '');
      }
    })
  }

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  let hoverMenus = document.getElementsByClassName('dropdown-menu__custom_hover');

  for(let i = 0; i < hoverMenus.length; i++){
    let hoverMenusDetails = hoverMenus[i].querySelector("details");

    hoverMenus[i].addEventListener('mouseover', function(){
      if (!hoverMenusDetails.hasAttribute('open')){
        hoverMenusDetails.setAttribute('open', '');
      }
    })

    hoverMenus[i].addEventListener('mouseout', function(){
      if (hoverMenusDetails.hasAttribute('open')){
        hoverMenusDetails.removeAttribute('open', '');
      }
    })
  }

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
